import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#FFFFFF]">
      <header className="bg-white/80 backdrop-blur-xl border-b border-[#E2DDD8] sticky top-0 z-50">
        <div className="w-full max-w-[900px] mx-auto px-6 md:px-12 py-4 flex items-center gap-4">
          <Link to="/login" className="text-[#1BB594] hover:underline">
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div className="flex items-baseline gap-1.5">
            <img src="/arpai_logo.png" alt="ARPAI" style={{height: '1.25rem'}} />
            <span className="text-xl font-bold text-[#2F2E2F] tracking-[0.15em]">GEO</span>
          </div>
        </div>
      </header>

      <main className="w-full max-w-[900px] mx-auto px-6 md:px-12 py-16">
        <h1 className="text-3xl sm:text-4xl tracking-tight font-black text-[#2F2E2F] mb-8">
          Terms of Service
        </h1>

        <div className="prose prose-slate max-w-none text-sm leading-relaxed text-slate-700 space-y-6">
          <p className="text-xs text-slate-400 italic">Published: June 2026. This document is subject to updates.</p>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">1. Subject of Agreement</h2>
          <p>This Terms of Service agreement (hereinafter — the Agreement) defines the terms of use of the ARPAI GEO AI brand visibility monitoring and analytics service (hereinafter — the Service).</p>
          <p>This Agreement is addressed to any individual or legal entity (hereinafter — the User) and is considered accepted upon registration in the Service and acceptance of these terms.</p>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">2. Description of Services</h2>
          <p>The Service Provider grants the User access to the following services:</p>
          <ul className="list-disc ml-6 space-y-1">
            <li>Brand visibility monitoring across AI search engines (ChatGPT, Perplexity, Google AI);</li>
            <li>Geo-monitoring by regions and cities worldwide;</li>
            <li>AI analytics: promotion strategy generation, topic and article creation;</li>
            <li>AI consultant (webmaster) for website analysis;</li>
            <li>Automated scheduled monitoring.</li>
          </ul>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">3. Pricing and Payment</h2>
          <p>Services are provided on a credit-based system. Operation costs are listed in the Pricing section of the Service.</p>
          <p>Users purchase credit packages through the payment system. Payments are processed in the currency specified at checkout.</p>
          <p>Welcome credits are provided free of charge upon registration and are not refundable.</p>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">4. Rights and Obligations</h2>
          <p><strong>The Service Provider undertakes to:</strong></p>
          <ul className="list-disc ml-6 space-y-1">
            <li>Ensure Service availability 24/7 (except for scheduled maintenance);</li>
            <li>Ensure the safety of User data;</li>
            <li>Not disclose User data to third parties without consent.</li>
          </ul>
          <p className="mt-4"><strong>The User undertakes to:</strong></p>
          <ul className="list-disc ml-6 space-y-1">
            <li>Provide accurate information during registration;</li>
            <li>Not use the Service for illegal purposes;</li>
            <li>Not share access credentials with third parties;</li>
            <li>Pay for services in a timely manner.</li>
          </ul>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">5. Liability</h2>
          <p>The Service Provider is not liable for the results of AI analysis. Data provided by the Service is for informational purposes only and does not constitute legal, financial, or other professional advice.</p>
          <p>The Service Provider does not guarantee the accuracy of AI search engine responses, as they are third-party products.</p>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">6. Refund Policy</h2>
          <p>Refunds for unused credits are available within 14 days of purchase, provided that the credits have not been used. To request a refund, please contact our support team.</p>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">7. Termination</h2>
          <p>The User may terminate this Agreement at any time by deleting their account. Upon account deletion, all data is destroyed in accordance with the Privacy Policy.</p>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">8. General Provisions</h2>
          <p>This Agreement is governed by applicable law. All disputes shall be resolved through negotiation, and if no agreement is reached, in the court at the location of the Service Provider.</p>
          <p>The Service Provider reserves the right to amend this Agreement with notification to Users through the Service.</p>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">9. Contact Information</h2>
          <p>For questions regarding this Agreement: support@arpai-geo.com</p>
        </div>
      </main>
    </div>
  );
};

export default TermsPage;
